module.exports = require('./helpers/bundle-url').getBundleURL('kBjr5') + "FantomLogo.59ea410b.svg";